import logger from '@spotify-internal/isomorphic-logger';
import { isDev } from '../../helpers/isDev';
import { getCookie } from '../getCookie';

export const debugMessage = (
  msg: any,
  level: 'log' | 'error' | 'info' | 'debug' = 'log',
) => {
  const shouldDebug = getCookie('sentryDebug') === 'true' || isDev;
  if (shouldDebug) {
    logger[level](msg);
  }
};
